export const colors = {
  backGroundSecondary: "#F2F4F6",
  gray50: "#FFFEFE",
  gray100: "#F5F5F5",
  gray200: "#CDCDCD",
  gray700: "#D5D3CE",
  blue50: "#F4F4FD",
  blue100: "#EAEAFC",
  blue200: "#D3D3F8",
  blue300: "#BAB9F5",
  blue400: "#9C9BF1",
  blue500: "#605DEC",
  blue700: "#524FC9",
  blue800: "#4745AE",
  blue900: "#3A388E",
  blue950: "#292865",
  milkGlass200: "#FDFCFA",
  milkGlass500: "#FAF7F2",
  milkGlass600: "#EEECE7",
  milkGlass800: "#B9B7B3",
  milkGlass900: "#979592",
  milkGlass950: "#6B6967",
  neutral50: "#FCFCFD",
  neutral100: "#F2F4F7",
  neutral200: "#7A7F89",
  neutral300: "#ABB1BA",
  nightlyWoods100: "#E7E7E7",
  nightlyWoods500: "#002E19",
  nightlyWoods600: "#002C18",
  nightlyWoods700: "#002715",
  nightlyWoods900: "#001C0F",
  nightlyWoods950: "#00140B",
  orange50: "#FEF4F2",
  orange300: "#FBBAAF",
  orange500: "#F7622B",
  orange600: "#EC5D29",
  orange700: "#D35425",
  orange750: "#BA4A21",
  orange800: "#B74820",
  green50: "#E9FFF5",
  green300: "rgba(0,163,90,0.35)",
  green500: "#00A35A",
  green600: "#007A3F",
  green700: "#006B3B",
  pink50: "#FFF2F5",
  pink300: "#FEADC3",
  pink500: "#FE1E7E",
  pink700: "#D91A6C",
  pink800: "#BC165D",
  pink900: "#99124C",
  pink950: "#6C0D36",
  amber50: "#FEFCE8",
  amber700: "#A16207",
  amber800: "#9B6B03",
  yellow: "#F6F416",
};

export const constants = {
  // Student-session tablet layout cutoff. Covers current iPads in landscape
  // (9th gen 1080, 10th/11th gen + Air 11" 1180, Pro 11" 1194 CSS px) while
  // staying under common laptop widths; the 13" iPads (1366+) get desktop.
  TABLET_MEDIA_QUERY: "(max-width: 1200px)",
  ACTIVITY: "Activity",
  GRADE_LEVEL: "Grade Level",
  DOMAIN: "Domain",
  CLUSTER: "Cluster",
  STANDARD: "Standard",
  ACTIVITY_PLACEHOLDER: "Select Activity",
  GRADE_LEVEL_PLACEHOLDER: "All Grades",
  DOMAIN_PLACEHOLDER: "All Domains",
  CLUSTER_PLACEHOLDER: "All Clusters",
  STANDARD_PLACEHOLDER: "All Standards",
  CRAZY_CALCULATOR: "Crazy Calculator",
  CRAZY_CALCULATOR_ENUM: "crazy_calculator",
  LETS_TALK: "Let's Talk",
  CONSENSUS_ENUM: "consensus",
  ACTIVITY_ID_READY_ROOM: "ready-room",
  ACTIVITY_ID_WAITING_ROOM: "waiting-room",
  ACTIVITY_ID_MULTIPLE_CHOICE: "multiple-choice",
  GROUP_CARD_VIEW_MESSAGE: "You can assign a standard to individual group codes by selecting from the drop-downs below",
  CRAZY_CALC_GROUP_CODE_CARD_MESSAGE: "*For Crazy Calculator sessions, OKO dynamically adjusts the difficulty of questions based on student responses.",
  SESSION_SUMMARY_PROMPT_CONSOLE_MESSAGE: "Enter an existing session id to get all of the required data for generating a new session summary.",
  FACILITATION_AI_PROMPT_CONSOLE_MESSAGE: "Enter an existing session id to get all the LLM events that occurred during that session.",
  EXPLANATION_PROMPT_CONSOLE_MESSAGE: "Enter comma-separated list of challenge ids to generate explanations for those challenges.",
  DASHBOARD: "Groups",
  SESSION_HISTORY: "Session Insights",
  EDUCATOR_PATH: "/educator",
  EDUCATOR_ROUTE_NAME: "EducatorProfile",
  EDUCATOR_LOGIN_PATH: "/educator/login",
  EDUCATOR_LOGIN_ROUTE_NAME: "EducatorLogin",
  ADMIN_LOGIN_PATH: "/admin/login",
  ADMIN_LOGIN_ROUTE_NAME: "AdminLogin",
  OKO_WEBSITE_URL: "https://www.okolabs.ai",
  SESSION_HISTORY_PATH: "/session_history",
  SESSION_HISTORY_ROUTE_NAME: "SessionHistory",
  LIVE_SESSIONS: "Live Sessions",
  LIVE_SESSIONS_PATH: "/live_sessions",
  LIVE_SESSIONS_ROUTE_NAME: "LiveSessions",
  WEEKLY_REPORTS: "Class Insights",
  WEEKLY_REPORTS_PATH: "/weekly_reports",
  WEEKLY_REPORTS_ROUTE_NAME: "WeeklyReports",
  STUDENT_REPORTS: "Student Reports",
  STUDENT_REPORTS_PATH: "/student_report",
  STUDENT_REPORTS_ROUTE_NAME: "StudentReports",
  STUDENT_ACTIVITY: "Student Activity",
  STUDENT_ACTIVITY_PATH: "/student_activity",
  STUDENT_ACTIVITY_ROUTE_NAME: "StudentActivity",
  PROFICIENCY: "Proficiency",
  PROFICIENCY_PATH: "/proficiency",
  PROFICIENCY_ROUTE_NAME: "Proficiency",
  RESOURCE_HUB: "Resource Hub",
  RESOURCE_HUB_PATH: "/resource_hub",
  RESOURCE_HUB_ROUTE_NAME: "ResourceHub",
  COLLABORATION_TREND: "Collaboration Trend",
  COLLABORATION_TREND_PATH: "/collaboration_trend",
  COLLABORATION_TREND_ROUTE_NAME: "CollaborationTrend",
  CLASS_REPORTS: "Class Reports",
  MANAGE_GROUPS: "Manage Groups",
  SESSION_REPORTS_SECTION: "Session Insights",
  BY_SESSION: "By Session",
  BY_LESSON: "By Lesson",
  BY_DATE: "By Date",
  DATA_REPORTS_SECTION: "Data Reports",
  SUPPORT_SECTION: "Support",
  CLASS_REPORTS_PATH: "/class_reports",
  CLASS_REPORTS_ROUTE_NAME: "ClassReports",
  SCHOOL_REPORTS: "School Reports",
  DISTRICT_REPORTS: "District Reports",
  SCHOOL_REPORTS_PATH: "/school_reports",
  SCHOOL_REPORTS_ROUTE_NAME: "SchoolReports",
  SETTINGS: "Settings",
  EDUCATOR_SETTINGS_PATH: "/educator/settings",
  EDUCATOR_SETTINGS_ROUTE_NAME: "EducatorSettings",
  STUDENT: "student",
  ANONYMOUS: "anonymous",
  GOOGLE: "google",
  CLEVER: "clever",
  CLASSLINK: "classlink",
  MICROSOFT: "microsoft",
  SESSION_SUMMARY_PROMPT_CONSOLE: "Session Insights By Session",
  SESSION_SUMMARY_PROMPT_CONSOLE_PATH: "/admin/session_summary_prompt_console",
  SESSION_SUMMARY_PROMPT_CONSOLE_ROUTE_NAME: "SessionSummaryPromptConsole",
  FACILITATION_AI_PROMPT_CONSOLE: "Facilitation AI Prompt Console",
  FACILITATION_AI_PROMPT_CONSOLE_PATH: "/admin/facilitation_ai_prompt_console",
  FACILITATION_AI_PROMPT_CONSOLE_ROUTE_NAME: "FacilitationAIPromptConsole",
  EXPLANATION_AI_PROMPT_CONSOLE: "Explanation AI Prompt Console",
  EXPLANATION_AI_PROMPT_CONSOLE_PATH: "/admin/explanation_ai_prompt_console",
  EXPLANATION_AI_PROMPT_CONSOLE_ROUTE_NAME: "ExplanationAIPromptConsole",
  CONSENSUS_QUESTIONS_RENDER: "Consensus Challenge Render",
  CONSENSUS_QUESTIONS_RENDER_PATH: "/admin/consensus/questions/render",
  CONSENSUS_QUESTIONS_RENDER_ROUTE_NAME: "AdminConsensusQuestionsRender",
  CONSENSUS_QUESTIONS_VIEW: "Consensus Challenge List",
  CONSENSUS_QUESTIONS_VIEW_PATH: "/admin/consensus/questions/view",
  CONSENSUS_QUESTIONS_VIEW_ROUTE_NAME: "AdminConsensusQuestionsView",
  CRAZY_CALCULATOR_QUESTIONS_RENDER: "Crazy Calc. Challenge Render",
  CRAZY_CALCULATOR_QUESTIONS_RENDER_PATH: "/admin/crazy_calculator/questions/render",
  CRAZY_CALCULATOR_QUESTIONS_RENDER_ROUTE_NAME: "AdminCrazyCalculatorQuestionsRender",
  WARM_UP_SETS_ADMIN: "Warm-Up Sets",
  WARM_UP_SETS_ADMIN_PATH: "/admin/warm-up-sets",
  WARM_UP_SETS_ADMIN_ROUTE_NAME: "AdminWarmUpSets",
  CRAZY_CALCULATOR_QUESTIONS_VIEW: "Crazy Calc. Challenge List",
  CRAZY_CALCULATOR_QUESTIONS_VIEW_PATH: "/admin/crazy_calculator/questions/view",
  CRAZY_CALCULATOR_QUESTIONS_VIEW_ROUTE_NAME: "AdminCrazyCalculatorQuestionsView",
  REPORTS: "Question Reports",
  REPORTS_PATH: "/admin/reports",
  REPORTS_ROUTE_NAME: "AdminReports",
  CS_REPORTS: "CS Reports",
  CS_REPORTS_PATH: "/admin/cs-reports",
  CS_REPORTS_ROUTE_NAME: "AdminCSReports",
  TEACHER_REPORTS_METRICS: "Teacher Reports Metrics",
  TEACHER_REPORTS_METRICS_PATH: "/admin/teacher-reports-metrics",
  TEACHER_REPORTS_METRICS_ROUTE_NAME: "AdminTeacherReportsMetrics",
  SESSION_REPLAY: "Session Replay",
  SESSION_REPLAY_PATH: "/admin/session-replay",
  SESSION_REPLAY_ROUTE_NAME: "SessionReplay",
  SEMANTIC_SEARCH: "Semantic Search",
  SEMANTIC_SEARCH_PATH: "/admin/semantic-search",
  SEMANTIC_SEARCH_ROUTE_NAME: "SemanticSearch",
  SESSION_ANALYZER: "Session Analyzer",
  SESSION_ANALYZER_PATH: "/admin/session-analyzer",
  SESSION_ANALYZER_ROUTE_NAME: "SessionAnalyzer",
  EXPERIMENTS_COMPARISON: "Experiments Comparison",
  TAGGER_PROMPT_EXPERIMENTS: "Tagger Prompt",
  TAGGER_PROMPT_EXPERIMENTS_PATH: "/admin/experiments/tagger",
  TAGGER_PROMPT_EXPERIMENTS_ROUTE_NAME: "TaggerPromptExperiments",
  TAGGER_DATASET_PREFIX: "[TAGGER]",
  STUDENT_FEEDBACK_EXPERIMENTS: "Student Feedback",
  STUDENT_FEEDBACK_EXPERIMENTS_PATH: "/admin/experiments/student-feedback",
  STUDENT_FEEDBACK_EXPERIMENTS_ROUTE_NAME: "StudentFeedbackExperiments",
  STUDENT_FEEDBACK_DATASET_PREFIX: "[STUDENT FEEDBACK]",
  BETTER_HINT_EXPERIMENTS: "Better Hint",
  BETTER_HINT_EXPERIMENTS_PATH: "/admin/experiments/better-hint",
  BETTER_HINT_EXPERIMENTS_ROUTE_NAME: "BetterHintExperiments",
  BETTER_HINT_DATASET_PREFIX: "[BETTER HINT]",
  CLIENT_ADMIN: "Client & School Admin",
  CLIENT_ADMIN_PATH: "/admin/clients",
  CLIENT_ADMIN_ROUTE_NAME: "ClientAdmin",
  CLIENT_ADMIN_NEW_PATH: "/admin/clients/new",
  CLIENT_ADMIN_NEW_ROUTE_NAME: "ClientAdminNew",
  CLIENT_ADMIN_DETAIL_PATH: "/admin/clients/:id",
  CLIENT_ADMIN_DETAIL_ROUTE_NAME: "ClientAdminDetail",
  CLIENT_ADMIN_EDIT_PATH: "/admin/clients/:id/edit",
  CLIENT_ADMIN_EDIT_ROUTE_NAME: "ClientAdminEdit",
  SCHOOL_ADMIN_NEW_PATH: "/admin/clients/:clientId/schools/new",
  SCHOOL_ADMIN_NEW_ROUTE_NAME: "SchoolAdminNew",
  SCHOOL_ADMIN_DETAIL_PATH: "/admin/schools/:id",
  SCHOOL_ADMIN_DETAIL_ROUTE_NAME: "SchoolAdminDetail",
  SCHOOL_ADMIN_EDIT_PATH: "/admin/schools/:id/edit",
  SCHOOL_ADMIN_EDIT_ROUTE_NAME: "SchoolAdminEdit",
  EDNITION_ADMIN: "Ednition Admin",
  EDNITION_ADMIN_PATH: "/admin/ednition",
  EDNITION_ADMIN_ROUTE_NAME: "EdnitionAdmin",
  FEATURE_FLAGS_ADMIN: "Feature Flags",
  FEATURE_FLAGS_ADMIN_PATH: "/admin/feature-flags",
  FEATURE_FLAGS_ADMIN_ROUTE_NAME: "FeatureFlagsAdmin",
  GROUPING_SIMULATION: "Grouping Simulation",
  GROUPING_SIMULATION_PATH: "/admin/grouping-simulation",
  GROUPING_SIMULATION_ROUTE_NAME: "GroupingSimulation",
  USER_ADMIN: "User Admin",
  USER_ADMIN_PATH: "/admin/users",
  USER_ADMIN_ROUTE_NAME: "UserAdmin",
  USER_ADMIN_DETAIL_PATH: "/admin/users/:id",
  USER_ADMIN_DETAIL_ROUTE_NAME: "UserAdminDetail",
  USER_ADMIN_EDIT_PATH: "/admin/users/:id/edit",
  USER_ADMIN_EDIT_ROUTE_NAME: "UserAdminEdit",
  GROUP_CODE_STANDARD_SEARCH: "Select Standard",
  GROUP_CODE_STANDARD_SEARCH_PATH: "/select_standard/:groupCode",
  GROUP_CODE_STANDARD_SEARCH_ROUTE_NAME: "GroupCodeStandardSearch",
  CREATE_QUICK_GROUP_PATH: "/create-quick-group",
  CREATE_QUICK_GROUP_ROUTE_NAME: "CreateQuickGroup",
  WARM_UP_PICKER_PATH: "/warm-up-challenges",
  WARM_UP_PICKER_ROUTE_NAME: "WarmUpPicker",
  CHALLENGES_REPORT_API_PATH: "report/challenges",
  CHALLENGES_BY_STANDARD_REPORT_API_PATH: "report/challenges_by_standard",
  QUESTION_HUMAN_ANALYZE: "Question Human Analyze",
  QUESTION_HUMAN_ANALYZE_PATH: "/admin/question-human-analyze",
  QUESTION_HUMAN_ANALYZE_ROUTE_NAME: "QuestionHumanAnalyze",
  EVALUATOR_REVIEW: "Evaluation Tools",
  EVALUATOR_REVIEW_PATH: "/admin/evaluator-review",
  EVALUATOR_REVIEW_ROUTE_NAME: "EvaluatorReview",
  EVALUATOR_REVIEW_FULL_VIEW_PATH: "/admin/evaluator-review/question/:id",
  EVALUATOR_REVIEW_FULL_VIEW_ROUTE_NAME: "EvaluatorReviewFullView",
  EVALUATOR_REVIEW_LESSON_PATH: "/admin/evaluator-review/lesson/:lessonId",
  EVALUATOR_REVIEW_LESSON_ROUTE_NAME: "EvaluatorReviewLesson",
  EVALUATOR_LC_REVIEW: "LC Alignment Review",
  EVALUATOR_LC_REVIEW_PATH: "/admin/evaluator-review/lc-alignment",
  EVALUATOR_LC_REVIEW_ROUTE_NAME: "LcAlignmentReview",
  SKILLS_PROFILE: "Skills Profile",
  SKILLS_PROFILE_PATH: "/admin/skills-profile",
  SKILLS_PROFILE_REVIEW: "SME Review",
  SKILLS_PROFILE_REVIEW_PATH: "/admin/skills-profile/review",
  SKILLS_PROFILE_REVIEW_ROUTE_NAME: "SkillsProfileReview",
  SKILLS_PROFILE_PROMPTS: "Tag Prompt",
  SKILLS_PROFILE_PROMPTS_PATH: "/admin/skills-profile/prompts",
  SKILLS_PROFILE_PROMPTS_ROUTE_NAME: "SkillsProfilePrompts",
  SKILLS_PROFILE_ITEM_SELECTION: "Item Selection",
  SKILLS_PROFILE_ITEM_SELECTION_PATH: "/admin/skills-profile/batches",
  SKILLS_PROFILE_ITEM_SELECTION_ROUTE_NAME: "SkillsProfileItemSelection",
  SKILLS_PROFILE_LLM_TAGS: "LLM Tags",
  SKILLS_PROFILE_LLM_TAGS_PATH: "/admin/skills-profile/llm-tags",
  SKILLS_PROFILE_LLM_TAGS_ROUTE_NAME: "SkillsProfileLlmTags",
  IM_QUESTION_BROWSER: "IM Question Browser",
  IM_QUESTION_BROWSER_PATH: "/admin/im-question-browser",
  IM_QUESTION_BROWSER_ROUTE_NAME: "ImQuestionBrowser",
  ADMIN_WEEKLY_REPORTS: "Session Insights by Date",
  ADMIN_WEEKLY_REPORTS_PATH: "/admin/weekly-reports",
  ADMIN_WEEKLY_REPORTS_ROUTE_NAME: "AdminWeeklyReports",
  ADMIN_NAV_EXPAND_ALL: "Expand all",
  ADMIN_NAV_COLLAPSE_ALL: "Collapse all",
  ADMIN_NAV_GROUP_MATH_PROBLEMS: "Math Problems",
  ADMIN_NAV_GROUP_AI_PROMPTS: "AI Prompts",
  ADMIN_NAV_GROUP_REPORTS: "Reports",
  ADMIN_NAV_GROUP_SESSION_DETAIL: "Session Detail",
  ADMIN_NAV_GROUP_LANGFUSE: "Langfuse",
  ADMIN_NAV_GROUP_USER_ADMIN: "User Admin & Feature Flag",
  ADMIN_NAV_GROUP_EVAL_SKILLS_PROFILE: "Eval: Skills Profile",
  ADMIN_NAV_GROUP_EVAL_LC_QUESTION: "Eval: LC-Question",
  ADMIN_NAV_GROUP_OTHER: "Other",
  LESSONS_STANDARDS: "Standards",
  LESSONS_STANDARDS_PATH: "/lessons-standards",
  LESSONS_STANDARDS_ROUTE_NAME: "LessonsStandards",
  VIEW_CHANGE_LESSON: "View & Change Lesson",
  VIEW_CHANGE_LESSON_PATH: "/view-change-lesson",
  VIEW_CHANGE_LESSON_ROUTE_NAME: "ViewChangeLesson",
  VIEW_CHANGE_STANDARD: "View & Change Standard",
  VIEW_CHANGE_STANDARD_PATH: "/view-change-standard",
  VIEW_CHANGE_STANDARD_ROUTE_NAME: "ViewChangeStandard",
  EDIT_GROUPS: "Edit Groups",
  EDIT_GROUPS_PATH: "/groups/edit",
  EDIT_GROUPS_ROUTE_NAME: "EditGroups",
  EDIT_GROUP_FOCUS: "Edit Group Focus",
  EDIT_GROUP_FOCUS_PATH: "/edit-group-focus",
  EDIT_GROUP_FOCUS_ROUTE_NAME: "EditGroupFocus",
  LESSON_EDIT_GROUP_FOCUS: "Edit Group Focus",
  LESSON_EDIT_GROUP_FOCUS_PATH: "/lesson-edit-group-focus",
  LESSON_EDIT_GROUP_FOCUS_ROUTE_NAME: "LessonEditGroupFocus",
  QUESTION_SET_PATH: "/question-set",
  QUESTION_SET_ROUTE_NAME: "QuestionSetView",
  CUSTOM_REPORT: "Weekly Report Narrative",
  CUSTOM_REPORT_PATH: "/admin/custom-report",
  CUSTOM_REPORT_ROUTE_NAME: "CustomReport",
  SOLO_TIME: "Solo Time",
  TEAM_TIME: "Team Time",
  GREAT_WORK: "GREAT WORK!",
  GREAT_TEAM_WORK: "Nice Job!",
  FINAL_ROUND: "FINAL ROUND",
};

export const getActivityName = (activity) => {
  let activityName;
  switch (activity) {
    case constants.CRAZY_CALCULATOR_ENUM:
      activityName = constants.CRAZY_CALCULATOR;
      break;
    case constants.CONSENSUS_ENUM:
      activityName = constants.LETS_TALK;
      break;
    default:
      activityName = "N/A";
  }
  return activityName;
};

// Validates a hostname:
//   - each label is alphanumeric, optional internal hyphens, no leading/trailing hyphen
//   - middle labels may contain digits (e.g. "k12", "5021") so domains like
//     classlink.k12.nj.us, app.dev.okolabs.ai, 5021.demo all pass
//   - final TLD label is alpha-only and >=2 chars
export const DOMAIN_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
export const FORBIDDEN_EMAIL_DOMAIN_CHARS = /[@#$%^&*(),!?{}[\]=<>/|\\]/g;

// `legacyLabels` are earlier wordings of the same option: reports retell survey
// answers as text, so historical sessions must still resolve to a canonical label.
export const CHALLENGE_SURVEY_OPTIONS = [
  { value: "HARD", label: "Too hard 😅", legacyLabels: ["That was way too hard 😅"], responseTitle: "We all feel that way sometimes.", responseBody: "In group time, feel encouraged to ask questions and make mistakes - that's how we learn!" },
  { value: "OK", label: "Tough, but I'm ready🗣️", legacyLabels: ["Tough, but I'm ready to talk it out 🗣️"], responseTitle: "Great!", responseBody: "Remember—great questions are just as valuable as great answers." },
  { value: "EASY", label: "I've got this! 💪", responseTitle: "Awesome!", responseBody: "Get ready to share your thoughts AND listen for questions from teammates." },
];

export const SESSION_SURVEY_OPTIONS = [
  { value: "NEED_HELP", label: "I need more help 🙋‍♀️", response: "You're a Brave Math Learner!\n\nThanks for being honest! We'll make sure your teacher knows you're looking for more support. Every feeling means you're thinking, learning, and growing. You can do this, and we're here to help! Keep exploring and asking questions!" },
  { value: "OK", label: "Getting better - but need more practice ✏️", response: "You're a Growing Math Star!\n\nAwesome job! Knowing you need practice shows your strength. Remember, struggling just means your brain is getting stronger! Keep practicing and you'll keep getting better!" },
  { value: "GREAT", label: "Great! I'm ready to help someone 💪", response: "Way to Go, Math Star!\n\nAmazing! Choosing to help others shares your brilliance and makes a big difference for the team. Your active participation helps everyone learn and grow! Keep collaborating, exploring, and shining!" },
];

export const CLIENT_TYPES = [
  { value: "district", label: "District" },
  { value: "charter_network", label: "Charter Network" },
  { value: "independent_school", label: "Independent School" },
  { value: "pilot", label: "Pilot" },
  { value: "individual", label: "Individual" },
];

export const US_STATES = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY",
];

export const parseLevelFromString = (str) => {
  if (!str) return null;
  if (typeof str === "number") return str;
  const match = str.match(/Level (\d+)/);
  return match ? parseInt(match[1], 10) : null;
};
